<template>
  <div class="page" v-wechat-title="$route.meta.title">

    <!--轮播图-->
    <div class="banner border-box"  >
      <Swiper :banners="banners" :type="'home'"></Swiper>
    </div>

    <!--热门景区-->
    <div class="conference-list p024">
      <template v-for="(item,index) in root">
        <!--<div class="conference-number"><b></b> 第{{index}}站</div>-->
        <div class="conference-item-parent" @click="toViewDetail(item.id,item.shopType)">
          <div class='conference-item border-box'>
            <div class="conference-item-img loadBg">
              <img class="img" v-lazy="item.logo" alt="">
            </div>
            <span class="conference-item-hover-text" v-if="item.shopType=='bagscenic'">景区合集包</span>
            <span class="conference-item-hover-text" v-else>讲解点{{item.spotnum}}个</span>
            <div class="conference-item-info clearfix">
              <div class="label-box fl">
                <div class="fl conference-item-title hide">{{item.name}}</div>
                <div class="fl left-info" v-if="item.juli!='...'" @click.stop="openMap(item)">
                  <img class="conference-item-address-icon" src="../../assets/station-icon-adress.png" alt="">
                  <span class="conference-item-rote">{{item.juli|initDistance}}</span>
                </div>
              </div>
              <div class="fr lineH60 right-info">
                <div v-if="item.listen>0" class='conference-item-info-label'>
                  <img src="../../assets/station-icon-listen.png" alt="">
                  <span class="icon-time">{{item.listen|initNumber}}</span>
                </div>
                <div v-if="item.buys>0" class='conference-item-info-label'>
                  <img src="../../assets/station-icon-buy.png" alt="">
                  <span class="icon-time">{{item.buys|initNumber1}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <p class="load-tip" ref="loadtip" v-show="loadEnd">{{loadText}}</p>
    </div>

    <div class="back-btn" v-if="specialId==64" @click="toBack"><img src="../../assets/back-station.png" alt="">返回</div>

    <!--系统维护蒙层-->
    <P400  v-if="P400==1"></P400>
  </div>


</template>

<script>

  import { mapState, mapMutations } from 'vuex'
  import Swiper from '../../components/Swiper'
  import P400 from '../../components/P400'
  import {getSpecialRoot} from "@/service/getData";
  import {wxGetPosition,wxShareme, getCityInfo,wxOpenMapLocation} from '@/utils/wechat'
  import {setStore, getStore, removeStore, loadMore} from '@/config/mUtils'

  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)

  export default {
    data(){
      return {
        specialId: '', //线路id
        userInfo: {}, //用户信息
        latlng: {lat:'',lng:''}, //经纬度信息
        banners:[],
        root:[],//景区列表
        total: 0, //景区总数
        page: 1,
        rows: 7,
        loadText: "数据加载中",
        loadEnd: false, //数据加载结束则赋值为true

        TimeStamp: new Date().getTime(),  //获取当前时间
        appKey: '',
        appKeyA: '',
        P400: 0, //系统维护中
      }
    },
    computed: {

    },
    created(){
      let self = this;

      this.$loading.show('数据加载中');
      this.appKey = this.$route.query.appKey || "";
      this.appKeyA = this.appKey
      if(this.appKey){
        this.appKey = encodeURIComponent(this.appKey)
        setStore("appKey", {"appKey":this.appKey});
        this.sendUserBrowse();
      }else{
        setStore("appKey", {"appKey":""});
      }

      this.specialId = this.$route.query.specialId || getStore("specialId") || "";
      if (this.specialId != "" && this.specialId != null && this.specialId != undefined) {
        setStore("specialId", this.specialId);
      }

      this.userInfo = getStore("userInfo");

      let cityInfo = getStore("cityInfo");
      if(cityInfo == null || cityInfo.citycode == null || cityInfo.citycode == ""  ){
        getCityInfo(function(res){
          self.latlng = res;
          self.cityInfo = getStore("cityInfo");
          self.initData(self.page);
        });
      }else {
        this.cityInfo = getStore("cityInfo");
        wxGetPosition(function(res){
          self.latlng ={ lat: res.latitude, lng: res.longitude };
          self.initData(self.page);
        });
      }
      window.addEventListener("scroll",this.handleFun);
    },
    beforeDestroy(){
      window.removeEventListener("scroll",this.handleFun)
    },
    methods: {

      //初始化数据
      async initData(page){
      this.loadEnd = false;
      let res = await getSpecialRoot({
        TimeStamp: this.TimeStamp,
        specialId: this.specialId,
        lat: this.latlng.lat || '',
        lng: this.latlng.lng || '',
        page: page,
        rows: this.rows,
        openid: this.userInfo.openid
      });
      console.log(res.data)
      if(res.errcode == "00000"){
        this.$loading.hide();
        this.loadEnd = true;
        this.banners = res.data.imgurls;
        this.total = res.data.total;
        this.$route.meta.title = res.data.title;

        let root = res.data.root
        if (page >= Math.ceil(this.total / this.rows)) {
          this.loadText = '已经到底了'
        } else {
          this.loadText = '加载更多'
        }
        if (root.length > 0) {
          this.root = [...this.root, ...root];
        } else {
          if (page == 1) {
            this.root = [];
            this.loadText = '暂无数据'
          } else {
            this.loadText = '已经到底了'
          }
        }


        var share = res.data.share;
        let link = '/station?specialId='+ this.specialId +'&appKey='+(this.appKey);
        if(share == null || share == "undefined" ){
          let title = '金牌解说 | '+ res.data.title;
          let desc = '历史会说话！金牌解说与您共享历史故事~';
          let img = res.data.imgurls[0].imgurl || '';

          if(this.specialId == 43){
            wxShareme(res.data.title,"当文物开口说话！金牌解说邀您倾听来自古老的声音~",img,link);
          }if(this.specialId == 41){
            wxShareme(res.data.title,"传播红色文化，弘扬革命精神",'https://filewc.geeker.com.cn/jpjs/upload/file/20180608/sitehonse4.jpg',link);
          }if(this.specialId == 48){
            wxShareme(res.data.title,"讲好新疆故事，开展文化润疆，聚合全疆博物馆，新疆文博云展览。",'https://filewc.geeker.com.cn/jpFile/scenic/images/xj/youxj.png',link);
          }else {
            wxShareme(title,desc,img,link);
          }
        }else {
          wxShareme(share.title,share.desc,share.logo,link);
        }



      }else {
        this.$toast(res.errmsg)
        this.P400 = 1;
        this.$route.meta.title = '请稍后访问...';
      }

    },

    handleFun: function (){
      let self = this;
      self.$nextTick(function() {
        loadMore(self,function(page){
          self.initData(page);
        });
      })
    },

    toViewDetail: function (id){
      this.$router.push({
        path: `/view-detail?${'shopid='+ id + '&TimeStamp='+ this.TimeStamp+'&appKey='+(this.appKey)}`
      });
    },
    toViewDetail(id,shopType){
      if(shopType == "buddhism"){
        this.$router.push({
          path: `/view-detail-sm?${'shopid='+ id + '&TimeStamp='+ this.TimeStamp+'&appKey='+(this.appKey)}`
        });
      }if(shopType == "bagscenic"){
        this.$router.push({
          path: `/view-detail-group?${'shopid='+ id + '&TimeStamp='+ this.TimeStamp+'&appKey='+(this.appKey)}`
        });
      }else {
        this.$router.push({
          path: `/view-detail?${'shopid='+ id + '&TimeStamp='+ this.TimeStamp+'&appKey='+(this.appKey)}`
        });
      }

    },

    //打开地图
    openMap: function (item){
      wxOpenMapLocation(item.lat, item.lng, item.name, item.address || '');
    },

    //返回
    toBack: function (){
      window.history.back()
    },


  },
  watch:  {

  },
  components: {
    Swiper,
    P400
  },
  //格式化数据
  filters: {
    initNumber: function (num) {
      if(num>10000){
        num = (num/10000).toFixed(2)+'万'
      }else if(num>1000){
        num = (num/1000).toFixed(2)+'千'
      }
      return num;
    },
    initDistance: function (num) {
      if(num>1000){
        num = (num/1000).toFixed(2)+'KM'
      }
      return num;
    },
    initNumber1: function (num) { //重置购买数据
      if(num>=1000){
        num = '1000+'
      }
      return num;
    }
  }
  }

</script>

<style scoped>
  @import "../../style/view.css";

  .page{ background-color: #f9f9f9; min-height: 100vh; padding-bottom: .2rem; }

  /* banner */
  .banner{ position: relative;height:15%;border-radius:.07rem; z-index: 2; }
  .swiper-box{ border-radius: 0;}

  /* 景区列表 */
  .conference-list{ background-color: #f9f9f9;}
  .conference-number{ position: relative; z-index: 1; display: inline-block; width: 1.1rem; height: .6rem; margin-top: .27rem; padding: 0 .388rem; font: .24rem/.6rem "Microsoft YaHei"; color: #000; border-radius: .6rem; background-color: #fff; box-shadow: 0 2px 5px #e3e3e3; -webkit-box-shadow: 0 3px 5px #ddd; }
  .conference-number b{ display: inline-block; width: .12rem; height: .12rem; margin-right: .15rem; background-color: #faaf39; border-radius: .12rem;vertical-align: middle; }
  .conference-number:before{ position: absolute; width: .07rem; height: .31rem; left: .41rem; top: -.31rem; background-color: #ffbb17; content: ''; }

  .conference-item-parent{ margin-top: .27rem; z-index: 2; }
  .conference-item-parent:before{ position: absolute; width: .07rem; height: .27rem; left: .41rem; top: -.27rem; background-color: #ffbb17; content: ''; }
  .conference-item{ position: relative; margin-top: 0; box-shadow: 0 2px 5px #e3e3e3; -webkit-box-shadow: 0 3px 5px #ddd;  }
  .conference-item-img,.conference-item-img img{ border-radius: .15rem .15rem 0 0;}
  .conference-item-hover-text{ left: .15rem; top: 0; }
  .conference-item-title{ padding-left: .1rem;}
  .conference-item-info{ overflow: hidden; }
  .conference-item-info-label{ margin-left: 0; margin-right: .1rem;}


  .back-btn{width: .92rem; height: .92rem; border-radius: 50%; z-index: 1000; position: fixed; bottom: 15vh; right: 2.7vw; background: #fff;border: 1px solid #faaf39!important; font-size: .24rem;color: #faaf39;line-height: .36rem;
    display: -webkit-box; display: -webkit-flex; display: flex; -webkit-box-orient: vertical; -webkit-box-direction: normal; -webkit-flex-direction: column; flex-direction: column;
    -webkit-box-align: center; -webkit-align-items: center; align-items: center; -webkit-box-pack: center; -webkit-justify-content: center; justify-content: center; }
  .back-btn img{ display: block; width: auto;height: .4rem}


</style>



// WEBPACK FOOTER //
// src/page/station/station.vue